import { CardFieldKeyType, GenericUIConfigurationType } from '../../@types';
import { TokenScheme } from '../../constants';
import { TokenexIFrameControl } from '../ui/controls/TokenexIFrameControl';
import { ExpiryControl } from '../ui/controls/ExpiryControl';

export const TokenexFieldMap: GenericUIConfigurationType<CardFieldKeyType> = {
  meta: {
    label: 'paymentDetails',
  },
  fields: {
    cardNumber: {
      component: TokenexIFrameControl,
      name: 'cardNumber',
      label: 'cardNumber',
      id: 'tokenexCardNumber',
      scheme: TokenScheme.Card,
      className: 'LongTextControl',
    },
    expiry: {
      component: ExpiryControl,
      name: 'cardExpire',
      label: 'cardExpire',
      className: 'ShortTextControl',
    },
    cvv: {
      component: TokenexIFrameControl,
      name: 'cvv',
      label: 'cvv',
      id: 'tokenexCardCvv',
      scheme: TokenScheme.CVV,
      className: 'ShortTextControl',
    },
    cardholderName: {
      name: 'cardholderName',
      label: 'cardholderName',
      className: 'LongTextControl',
    },
  },
};
